<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
      >
        Name
      </th>
      <th
        scope="col"
        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        SKU
      </th>
      <th
        scope="col"
        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Total Pcs
      </th>
      <th
        scope="col"
        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        Total Sales
      </th>
      <th scope="col" class="relative px-6 py-3">
        <span class="sr-only">Actions</span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
